export default __webpack_public_path__ + "static/media/dashboard.48b2ba0e.png";